import React from 'react'
import {connect} from 'react-redux'
import {Modal} from '@lazarusai/forms-ui-components'
import '../styles/ResourcesModal.css'

// Actions
import {storePayload} from '../actions/storePayload.js'

function ReferencesModal(props) {
  const content = (
    <div className='resources-modal-content'>
      <p className='modal-header'>{props.headerText}</p>
      <div className='resource-cards'>
        <p
          className='modal-subheader'
        >
          {props.subheaderText}
        </p>
        <div>
          {props.refData && Object.keys(props.refData).map((title, i) => {
            const url = props.refData[title]
            return (
              <div
                className='resource-card'
                key={`card-${i}`}
              >
                <p className='resource-card-title'>
                  {title}
                </p>
                <a
                  href={url}
                  target='_blank'
                  rel="noreferrer"
                >
                  Visit Website
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
  return (
    <Modal
      isVisible={props.isVisible}
      showClose={true}
      showCancel={false}
      showConfirm={false}
      showBackdrop={true}
      outsideClickDismisses={true}
      content={content}
      theme={props.theme}
      onCancel={props.onCancel}
    />
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSubSection: state.userReducer.selectedSubSection,
  isResourcesModal: state.userReducer.isResourcesModal,
  isResourcesModalShowing: state.userReducer.isResourcesModalShowing,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(ReferencesModal)
